import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/AdaptiveCardRenderer.module_built.css";
const classes = {"adaptive-card-renderer":"wyhD4jG_adaptive-card-renderer"}
export default classes

const _adaptive_card_renderer0 = classes["adaptive-card-renderer"]
export { _adaptive_card_renderer0 as "adaptive-card-renderer" }
